/**
 * @module services/liquidation
 * @description Servicio HTTP para el módulo de liquidación de prestaciones
 */
import api from "./api";

export default {
  /** @param {Object} params - status, origin, billingYear, billingMonth, searchInput, offset, limit */
  get: (params) =>
    api.get("/liquidation-items", { params }).then((r) => r.data),
  /** @param {string} id */
  getById: (id) => api.get(`/liquidation-items/${id}`).then((r) => r.data),
  /** @param {{ billingYear, billingMonth }} params */
  getSummary: (params) =>
    api.get("/liquidation-items/summary", { params }).then((r) => r.data),
  /** @param {string} id @param {{ invoiceData, notes }} data */
  saveInvoice: (id, data) =>
    api.put(`/liquidation-items/${id}/invoice`, data).then((r) => r.data),
  /** @param {string} id @param {FormData} formData */
  uploadInvoiceFile: (id, formData) =>
    api
      .put(`/liquidation-items/${id}/invoice-file`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((r) => r.data),
  /** @param {string} id */
  getInvoiceFileUrl: (id) =>
    api.get(`/liquidation-items/${id}/invoice-file`).then((r) => r.data),
  /** @param {string} id @param {{ status, notes }} data */
  updateStatus: (id, data) =>
    api.put(`/liquidation-items/${id}/status`, data).then((r) => r.data),
  /** @description Obtiene configuración de tolerancia */
  getToleranceConfig: () =>
    api.get("/liquidation-items/tolerance-config/get").then((r) => r.data),
  /** @param {Object} data - Configuración de tolerancia a guardar */
  saveToleranceConfig: (data) =>
    api
      .put("/liquidation-items/tolerance-config/save", data)
      .then((r) => r.data),
};
